var styles = {
  "Grid": "Polaris-Grid"
};
export { styles as default };